module.exports = __webpack_public_path__ + "static/media/forest-360.039d0a9d.jpeg";